import React from "react"

import { ExternalLink, PackageOpen } from "lucide-react"

import { Button } from "@/components/ui/button"

import DashboardLayout from "../layouts/DashboardLayout"

// Deliberately not defaulted: an unset variable must not silently point a non-prod
// build at the production Collections app.
const COLLECTIONS_APP_URL: string | undefined = import.meta.env.VITE_COLLECTIONS_APP_URL

const Collections: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="flex flex-col items-center justify-center py-24 px-4">
        <div className="max-w-lg w-full text-center space-y-6">
          <div className="mx-auto w-14 h-14 rounded-full bg-palette-jungleGreen100 flex items-center justify-center">
            <PackageOpen className="text-palette-jungleGreen600" size={26} />
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-semibold text-palette-jungleGreen900">
              Collections tooling has moved
            </h1>
            <p className="text-sm text-palette-jungleGreen600">
              Collections planning, monitoring and configuration now live in their own app. This
              admin panel no longer manages collection routes.
            </p>
          </div>

          {COLLECTIONS_APP_URL ? (
            <Button asChild className="gap-2">
              <a href={COLLECTIONS_APP_URL} target="_blank" rel="noreferrer">
                Go to Collections
                <ExternalLink size={16} />
              </a>
            </Button>
          ) : (
            <p className="text-sm text-palette-jungleGreen600">
              The Collections app URL is not configured for this environment. Set
              VITE_COLLECTIONS_APP_URL to enable the link.
            </p>
          )}
        </div>
      </div>
    </DashboardLayout>
  )
}

export default Collections
